export enum SubscriptionStatusEnum {
  INITIALIZED = 'INITIALIZED',
  VALIDATED = 'VALIDATED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TERMINATED = 'TERMINATED',
  CANCELLED = 'CANCELLED'
}
